import React, { useEffect, useState } from 'react';
import PrivateLayout from '../../../layouts/PrivateLayout/PrivateLayout';
import { Button, Datepicker, Dropdown, Spinner } from 'flowbite-react';
import { FaEllipsisH, FaPlusCircle } from 'react-icons/fa';
import CustomTable from '../../../components/Table/CustomTable';
import downloadIcon from '../../../assets/document-download.png';
import filterIcon from '../../../assets/filterIcon.png';
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate';
import modalIcon from '../../../assets/Featured icon (1).png';
import client from '../../../api/client';
import AddCustomersModal from './AddCustomersModal';
import showToast from '../../../components/CustomToast/toastHelper';
import { ColumnCustomers, CustomersData } from '../../../types/TablesTypes/Customers';
import StatusView from '../../../components/StatusView/StatusView';
import CustomerDetailsModal from './CustomerDetailsModal';
import CustomModal from '../../../components/Modal/CustomModal';

const Customers = () => {
    const [customers, setCustomers] = useState<any>();
    const [tableRow, setTableRow] = useState<any[]>();
    const [selectedCustomer, setSelectedCustomer] = useState<any>()
    const [filters, setFilters] = useState({
        toDate: '',
        fromDate: '',
        customername: '',
        mobilenumber: '',
        email: '',
        status: '',
    });
    const [bearer, setBearer] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showCustomerDetails, setShowCustomerDetails] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true);
    const [isExport, setIsExport] = useState<boolean>(false)
    const [isExportReady, setIsExportReady] = useState<boolean>(false);
    const [isExportLoading, setIsExportLoading] = useState<boolean>(false);

    const clickExport = async () => {
        setIsExport(true);
        setIsExportLoading(true)
        await fetchCustomers();

        if (customers && customers.items?.length > 0) {
            setIsExportReady(true);
        }

        setIsExportLoading(false);
    };


    const handleFilterChange = (filterName: string, value: string) => {
        setFilters({
            ...filters,
            [filterName]: value,
        });
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            await fetchCustomers();
            setLoading(false)
        };
        fetchData();
    }, [filters, bearer]);

    const blackListOrWhiteListUser = async (user: any, action: string) => {
        const payload = {
            customerEmail: user.emailAddress,
            action: action,
            reason: 'test',
        };
        try {
            const response = await client.post('/subsidiary/customer/blacklist-whitelist', payload);
            const message = response?.data?.message;
            showToast(message, 'success');
            fetchCustomers();
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, 'error');
            }
        }
    };

    const fetchCustomers = async () => {
        try {
            const apiUrl = '/subsidiary/dashboard/fetch/customers';
            const params = new URLSearchParams(filters).toString();
            const response = await client.get(`${apiUrl}?${params}`);

            setCustomers(response.data.data);
            const message = response?.data?.message;
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, 'error');
            }
        }
    };

    const dataCustomers = () => {
        const tempArr: CustomersData[] = [];

        customers?.items
            ?.slice(0)
            .reverse()
            .forEach((customer: any, index: number) => {
                let action = customer?.status == "Active" ? "blacklist" : "whitelist"
                tempArr.push({
                    customerName: customer?.customerName,
                    emailAddress: customer?.emailAddress,
                    mobileNumber: customer?.mobileNumber,
                    countryName: customer?.countryName,
                    status: (
                        <StatusView
                            status={customer?.status}
                            green='Active'
                            red='Blacklisted'
                        />
                    ),
                    action: (
                        <Dropdown label={<FaEllipsisH />} inline arrowIcon={false} placement='right-start'>
                            <Dropdown.Item onClick={() => { setShowCustomerDetails(true); setSelectedCustomer(customer) }}>View Details</Dropdown.Item>
                            <Dropdown.Item onClick={() => blackListOrWhiteListUser(customer, action)}>{customer?.status == "Active" ? "Blacklist User" : "Whitelist User"}</Dropdown.Item>
                        </Dropdown>
                    ),
                });
            });
        return tempArr;
    };

    useEffect(() => {
        const fetch = async () => {
            setTableRow(await dataCustomers());
        };
        fetch();
    }, [customers?.items]);

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleCustomerAdded = async () => {
        await fetchCustomers();
        handleCloseModal()
    };

    return (
        <>
            <DashboardPagesTemplate
                title='Customers'
                children={
                    showModal ?
                        <AddCustomersModal
                            onClose={handleCloseModal}
                            onCustomerAdded={handleCustomerAdded}
                        /> : showCustomerDetails ? <CustomerDetailsModal customer={selectedCustomer} /> : null
                }
                dataToExport={customers?.items}
                modalIcon={modalIcon}
                show={showModal}
                openModal={handleOpenModal || setShowCustomerDetails(true)}
                closeModal={handleCloseModal || setShowCustomerDetails(false)}
                filters={filters}
                onFilterChange={setFilters}
                apiUrl='/subsidiary/dashboard/fetch/customers'
                data={tableRow ? tableRow : []}
                actions={['Blacklist Customer', 'View Details']}
                exportButtonExists={true}
                dropdownItems={["All", 'Active', 'Blacklisted']}
                buttonLabel='Add New Customer'
                buttonIcon={<FaPlusCircle />}
                headings={ColumnCustomers}
                showSearch={false}
                ctaButtonExists={true}
                emptyMessage='You do not have any customers yet'
                statusKey='status'
                loading={loading}
                clickExportButton={clickExport}
                exportButtonLoading={isExportLoading}
                exportButtonClicked={isExport}
            />
            {loading && (
                <div className="flex justify-center items-center">
                    <Spinner size="xl" />
                </div>
            )}
        </>
    );
};

export default Customers;
